if (!customElements.get('quick-cart-drawer')) {
  class QuickCartDrawer extends HTMLElement {
    constructor() {
      super();

      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', this.init.bind(this));
        this.parentElement.addEventListener('shopify:section:select', () => this.open());
        this.parentElement.addEventListener('shopify:section:deselect', () => this.close());
      }
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.toggleState = false;

      if (!this.classList.contains('is--open')) {
        document.querySelector('body').classList.remove('overflow-hidden');
      }

      this.querySelector('.button--close').addEventListener('click', this.close.bind(this));
      this.querySelector('.quick-cart-drawer__backdrop').addEventListener('click', this.close.bind(this));

      this.querySelector('.quick-cart-drawer__blocks').addEventListener('keydown', e => {
        if (e.key === 'Escape' && this.toggleState) {
          this.close();
        }

        if (this.toggleState) {
          const focusableElements = this.querySelectorAll(
            'button, [href], input, select, label, textarea, [tabindex]:not([tabindex="-1"])'
          );

          const firstFocusableElement = focusableElements[0];
          const lastFocusableElement = focusableElements[focusableElements.length - 1];

          let isTabPressed = e.key === 'Tab';

          if (!isTabPressed) {
            return;
          }

          if (e.shiftKey) {
            if (document.activeElement === firstFocusableElement) {
              e.preventDefault();
              lastFocusableElement.focus();
            }
          } else {
            if (document.activeElement === lastFocusableElement) {
              e.preventDefault();
              firstFocusableElement.focus();
            }
          }
        }
      });

      this.initTriggers();
    }

    initTriggers() {
      const observer = new MutationObserver(() => {
        document.querySelectorAll('.quick-cart-drawer__trigger').forEach(element => {
          if (!element._init) {
            element.addEventListener('click', event => {
              this.fetchProductForQuickCartDrawer(event);
            });

            element._init = true;
          }
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    async fetchProductForQuickCartDrawer(event) {
      /** stop autoplay on quick cart trigger */
      if (event.target.closest('card-product-slider')) {
        event.target.closest('card-product-slider').slider.autoplay.stop();
        event.target.closest('card-product-slider').classList.add('product--open-on-quick-cart');
      }

      const isRecommendations = event.target.classList.contains(
        'quick-cart-drawer__trigger--recommendations'
      );

      const productCard = event.target.closest('product-card');
      let productOptions = null;

      if (!isRecommendations) {
        if (!productCard) return;

        // get all checked options
        productOptions = productCard.querySelectorAll(
          'input[type="radio"]:checked, select'
        );
      }

      const trigger = event.target.closest('[data-product-url]');

      if (!trigger) {
        console.warn('Quick cart: trigger with data-product-url not found');
        return;
      }

      trigger.classList.toggle('is--loading');

      try {
        // Dynamiczne pobieranie prefiksu rynku/języka
        let fetchPrefix =
          this.getAttribute('data-root-url') ||
          window.Shopify.routes.root ||
          '';

        if (fetchPrefix.endsWith('/')) {
          fetchPrefix = fetchPrefix.slice(0, -1);
        }

        const productCardResponse = await fetch(
          `${fetchPrefix}${trigger.dataset.productUrl}/?view=quick-cart`
        );

        if (!productCardResponse) return;

        const productCardHTML = await productCardResponse.text();
        const productCardResponseWrapper = document.createElement('DIV');

        productCardResponseWrapper.insertAdjacentHTML(
          'beforeend',
          productCardHTML
        );

        if (!productCardResponseWrapper.querySelector('.quick-cart-product')) {
          console.warn(
            'Quick cart: response does not contain .quick-cart-product',
            trigger.dataset.productUrl
          );
          return;
        }

        this.querySelector('.quick-cart-drawer__main').innerHTML = '';

        this.querySelector('.quick-cart-drawer__main').append(
          productCardResponseWrapper.querySelector('.quick-cart-product')
        );

        this.sliderInstance = new Swiper(
          '.quick-cart-drawer__media-swiper',
          {
            slidesPerView: 1.25,
            spaceBetween: 8,
            freeMode: {
              enabled: true
            },
            breakpoints: {
              750: {
                slidesPerView: 2
              }
            }
          }
        );
      } catch (error) {
        console.error('Quick cart error:', error);
      } finally {
        trigger.classList.toggle('is--loading');

        if (!isRecommendations && productOptions) {
          // update quick cart drawer options with product options
          productOptions.forEach(productOption => {
            let productOptionName = productOption.name;
            const optionSectionIdAttribute =
              productOption.dataset?.sectionId;

            if (optionSectionIdAttribute) {
              productOptionName = productOptionName.replace(
                optionSectionIdAttribute,
                ''
              );
            }

            const quickCartDrawerOption = this.querySelector(
              `[name="${CSS.escape(
                productOptionName
              )}-quick-cart-product"][value="${CSS.escape(
                productOption.value
              )}"]`
            );

            /*
             * KLUCZOWA POPRAWKA:
             * jeżeli opcja nie istnieje w quick cart,
             * pomijamy ją zamiast wywalać cały JS.
             */
            if (!quickCartDrawerOption) {
              console.warn(
                'Quick cart: option not found',
                productOptionName,
                productOption.value
              );
              return;
            }

            const quickCartDrawerOptionLabel =
              quickCartDrawerOption.parentElement.parentElement.querySelector(
                'legend'
              );

            // before updating radio button state, remove checked attribute for specific name
            this.querySelectorAll(
              `[name="${productOptionName}"]`
            ).forEach(radioInput => {
              radioInput.removeAttribute('checked');

              const li = radioInput.closest('li');

              if (li) {
                li.classList.remove('checked');
              }
            });

            if (quickCartDrawerOption) {
              quickCartDrawerOption.setAttribute('checked', '');

              if (quickCartDrawerOptionLabel) {
                const quickCartDrawerOptionLabelSpan =
                  quickCartDrawerOptionLabel.querySelector(
                    '[data-selected-variant]'
                  );

                if (quickCartDrawerOptionLabelSpan) {
                  quickCartDrawerOptionLabelSpan.innerHTML =
                    productOption.value;
                }
              }
            }

            // update variant id in product card with selected variant id
            const quickCartProductCard =
              this.querySelector('product-card');

            const quickCartVariantInput =
              quickCartProductCard
                ? quickCartProductCard.querySelector(
                    'input[name="id"]'
                  )
                : null;

            const sourceVariantInput =
              productCard.querySelector('input[name="id"]');

            if (
              quickCartVariantInput &&
              sourceVariantInput
            ) {
              quickCartVariantInput.value =
                sourceVariantInput.value;
            }

            // update radio button state
            if (quickCartDrawerOption) {
              const li =
                quickCartDrawerOption.closest('li');

              if (li) {
                li.classList.add('checked');
              }
            }

            // initialise for disabled states to be checked and updated
            if (
              quickCartProductCard &&
              typeof quickCartProductCard.init === 'function'
            ) {
              quickCartProductCard.init();
            }
          });
        }

        // short wait before opening drawer
        setTimeout(() => {
          this.open();
        }, 500);

        // update label when variant is selected
        const drawerMain = this.querySelector(
          '.quick-cart-drawer__main'
        );

        if (drawerMain) {
          drawerMain
            .querySelectorAll('.variant-option-radio-input')
            .forEach(radioInput => {
              radioInput.addEventListener(
                'change',
                event => {
                  const quickCartDrawerOptionLabel =
                    event.target.parentElement.parentElement.querySelector(
                      'legend'
                    );

                  const quickCartDrawerOptionLabelSpan =
                    quickCartDrawerOptionLabel
                      ? quickCartDrawerOptionLabel.querySelector(
                          '[data-selected-variant]'
                        )
                      : null;

                  if (
                    quickCartDrawerOptionLabelSpan
                  ) {
                    quickCartDrawerOptionLabelSpan.innerHTML =
                      event.target.value;
                  }

                  // update variant id in product card with selected variant id
                  const selectedVariantInput =
                    this.querySelector(
                      ".product-card__add-to-cart--form input[name='id']"
                    );

                  if (!selectedVariantInput) {
                    return;
                  }

                  const selectedVariantId =
                    selectedVariantInput.value;

                  // get product variants data
                  const currentProductCard =
                    this.querySelector('product-card');

                  if (
                    !currentProductCard ||
                    !currentProductCard.variantsObj
                  ) {
                    return;
                  }

                  const productVariantsData =
                    currentProductCard.variantsObj;

                  const featuredMedia =
                    productVariantsData.find(
                      variant =>
                        variant.id == selectedVariantId
                    )?.featured_media;

                  if (featuredMedia) {
                    this.setActiveMedia(
                      featuredMedia.id
                    );
                  }
                }
              );
            });
        }
      }
    }

    setActiveMedia(id) {
      const mediaFound = Array.from(
        this.querySelectorAll('[data-media-id]')
      ).find(
        media =>
          Number(media.dataset.mediaId) === id
      );

      if (
        mediaFound &&
        this.sliderInstance
      ) {
        this.sliderInstance.slideTo(
          Number(mediaFound.dataset.index)
        );
      }
    }

    toggle() {
      if (!this.toggleState) {
        this.open();
      } else {
        this.close();
      }
    }

    open() {
      this.toggleState = true;

      document
        .querySelector('body')
        .classList.add('overflow-hidden');

      const quickCartDrawer =
        document.querySelector(
          '.quick-cart-drawer__blocks'
        );

      if (!quickCartDrawer) {
        return;
      }

      const closeButton =
        quickCartDrawer.querySelector(
          '.button--close'
        );

      quickCartDrawer.setAttribute(
        'tabindex',
        '0'
      );

      if (closeButton) {
        closeButton.setAttribute(
          'tabindex',
          '0'
        );
      }

      this.classList.add('is--open');

      this.opened();

      const firstFocusableElement =
        this.querySelector(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );

      if (firstFocusableElement) {
        firstFocusableElement.focus();
      }
    }

    close() {
      this.toggleState = false;

      const shopTheLookDrawer =
        document.querySelector(
          'shop-the-look-drawer'
        );

      if (
        shopTheLookDrawer &&
        !shopTheLookDrawer.classList.contains(
          'is--open'
        )
      ) {
        document
          .querySelector('body')
          .classList.remove(
            'overflow-hidden'
          );
      }

      if (!shopTheLookDrawer) {
        document
          .querySelector('body')
          .classList.remove(
            'overflow-hidden'
          );
      }

      this.classList.remove('is--open');

      this.closed();
      this.toggleAriaExpanded();

      /** start autoplay on quick cart drawer close */
      if (
        document.querySelector(
          'card-product-slider.product--open-on-quick-cart'
        )
      ) {
        const slider =
          document.querySelector(
            'card-product-slider.product--open-on-quick-cart'
          );

        if (
          slider.slider &&
          slider.slider.autoplay
        ) {
          slider.slider.autoplay.start();
        }

        slider.classList.remove(
          'product--open-on-quick-cart'
        );
      }
    }

    toggleAriaExpanded(event) {
      if (event) {
        if (event.target.closest('button')) {
          event.target
            .closest('button')
            .setAttribute(
              'aria-expanded',
              true
            );
        }

        const closeButton =
          this.querySelector(
            '.button--close'
          );

        if (closeButton) {
          closeButton.setAttribute(
            'aria-expanded',
            true
          );
        }
      } else {
        document
          .querySelectorAll(
            '[aria-controls="quick-cart-drawer"]'
          )
          .forEach(button => {
            button.setAttribute(
              'aria-expanded',
              false
            );
          });
      }
    }

    opened() {
      const openedEvent = new Event(
        'opened',
        {
          bubbles: true
        }
      );

      this.dispatchEvent(openedEvent);
    }

    closed() {
      const closedEvent = new Event(
        'closed',
        {
          bubbles: true
        }
      );

      this.dispatchEvent(closedEvent);
    }
  }

  customElements.define(
    'quick-cart-drawer',
    QuickCartDrawer
  );
}